import {RECIPE_SERVINGS_DATA} from '../../constants/recipe';
import {initArticleBottomNav} from '../../modules/article-bottom-nav';
import {initArticleReactions} from '../../modules/article-reactions';
import {initArticleShareWidget} from '../../modules/article-share-widget';
import {initArticleTableContent} from '../../modules/article-table-content';
import {initAutoGeneratedContent} from '../../modules/auto-generated-content';
import {renderArticleComments} from '../../modules/comments/comment-article-init';
import {initEmbeds} from '../../modules/custom-html';
import enableInfiniteLoader from '../../modules/infinite';
import {renderGolosNarodaWidgetInInfinite} from '../../modules/widgets/golos-naroda/golos-naroda-widget-infinite';
import {isDesktop} from '../../modules/widgets/golos-naroda/helpers';
import loadFullscreenAd from '../../services/monetization/fullscreen-ad';
import {initLatestInTrendAB} from '../../website-ui/latest-in-trend';
import {initArticleSummary} from '../../website-ui/modules/article-summary';
import {localGet} from '../ajax/promise';
import {observeWidget} from '../analytics/article-widgets';
import {publishEvent} from '../analytics/pub-sub';
import {ANALYTIC_EVENTS} from '../analytics/pub-sub/constants';
import initCounter from '../counter';

import {handleLanguageSwitcherEvents} from './article-language-switcher';
import {loadEmbeds} from './embeds-loader';
import getContentTypeObserver from './get-content-type-observer';
import {setTargetingByContentType} from './targeting';

const INDEX_TO_LOAD_FULLSCREEN_AD = 3;
const INDEX_TO_ADD_GOLOS_NARODA_WIDGET = 1;

const loadContentTypeJson = async (id, advertisementId) => {
  if (!id) {
    return Promise.resolve(null);
  }

  const queryString = advertisementId ? `?advertisementId=${advertisementId}` : '';

  const articleResponse = await localGet(`${window.location.origin}/ajax/post-json/${id}${queryString}`);

  return JSON.parse(articleResponse);
};

const infiniteLoaderData = {defaultPage: 1, margins: {top: 2, bottom: 2}, htmlKey: 'content'};

export const initInfiniteLoaderContentType = initialData => (listNextContentTypes, sendEventPage) => {
  const {
    isMobile,
    $initialContentType,
    $infiniteContainer,
    addEventHandlers,
    widgetsObservers,
    getCommentsCount,
    handleOneSignalEmbedAnalyticEvents
  } = initialData;

  let contentType = listNextContentTypes?.[0];

  if ($infiniteContainer && contentType?.id) {
    const fullListContentTypes = [{id: $initialContentType?.dataset?.id}, ...listNextContentTypes];

    getContentTypeObserver().observe($initialContentType);

    enableInfiniteLoader({
      ...infiniteLoaderData,
      $container: $infiniteContainer,
      loadNext: () => loadContentTypeJson(contentType.id, contentType.advertisementId),
      beforeOnLoaded: (data = {}, contentTypeIndex, enabled) => {
        if (enabled) {
          window.Site.targetingContentTypes = setTargetingByContentType({
            targetingContentTypes: window.Site.targetingContentTypes,
            targeting: window.Site.targeting,
            contentTypeId: contentType.id,
            data
          });
        }
        publishEvent(ANALYTIC_EVENTS.RECOMMENDATION, {
          articleId: fullListContentTypes[contentTypeIndex - 1]?.id, eventType: 'scroll'
        });
        publishEvent(ANALYTIC_EVENTS.ARTICLE_SCROLL, {
          contentTypeIndex
        });
      },
      onLoaded(contentTypeIndex, {analytics_data}) {
        const $currentContentType = document.querySelector(`.js-article[data-id="${contentType.id}"]`);

        if ($currentContentType) {

          let prevReferer = fullListContentTypes[contentTypeIndex - 1]?.url;

          const nextReferer = fullListContentTypes[contentTypeIndex + 1]?.url;

          if (contentTypeIndex === 1) {
            prevReferer = window.location.href;
          }

          getContentTypeObserver(
            analytics_data,
            sendEventPage,
            {
              next: nextReferer,
              prev: prevReferer
            }
          ).observe($currentContentType);
          const $bottomNavContainer = $currentContentType.querySelector('.js-article-bottom-nav-menu');
          const articleId = contentType.id.toString();
          const $coverImage = $currentContentType.querySelector('.js-article-cover-image');

          addEventHandlers($currentContentType, isMobile);
          handleOneSignalEmbedAnalyticEvents($currentContentType.querySelector('.one-signal-custom-link'));
          initArticleSummary($currentContentType);
          renderArticleComments($currentContentType.querySelector('.js-preview-comments'), contentType.id.toString());
          initArticleTableContent($currentContentType);
          initLatestInTrendAB(articleId);
          initArticleReactions($currentContentType.querySelector('.js-article-reactions'), contentType.id.toString());
          initArticleShareWidget(
            $currentContentType.querySelector('.js-article-share'),
            contentType.id.toString(),
            isMobile
          );
          initEmbeds($currentContentType);
          handleLanguageSwitcherEvents(articleId);

          const autogeneratedContentElement = $currentContentType.querySelector('.js-autogenerated');

          if (autogeneratedContentElement) {
            initAutoGeneratedContent(autogeneratedContentElement);
          }

          if (isMobile) {
            initArticleBottomNav(
              $bottomNavContainer,
              articleId,
              isMobile,
              $coverImage
            );
          } else {
            initArticleBottomNav($currentContentType.querySelector('.js-article-widget'), articleId);
          }

          getCommentsCount(contentType.id);
          const $counter = $currentContentType.querySelector('.js-counter');

          if ($counter) {
            initCounter({
              ...RECIPE_SERVINGS_DATA,
              $container: $counter
            });
          }

          loadEmbeds($currentContentType);

          contentType = listNextContentTypes?.[contentTypeIndex] || {};
          observeWidget({
            observer: widgetsObservers?.commentsWidgetObserver,
            $element: $currentContentType.querySelector('.js-comments') || $currentContentType.querySelector('.js-preview-comments') /* eslint-disable-line max-len */
          });
          observeWidget({
            observer: widgetsObservers?.shareWidgetObserver,
            $element: $currentContentType.querySelector('.js-share')
          });

          if (contentTypeIndex === INDEX_TO_ADD_GOLOS_NARODA_WIDGET) {
            const container = isDesktop() ? $currentContentType.nextElementSibling : $currentContentType;

            renderGolosNarodaWidgetInInfinite(container);
          }
        }

        if (contentTypeIndex === INDEX_TO_LOAD_FULLSCREEN_AD) {
          loadFullscreenAd(null, null, () => {});
        }
      }
    });
  }
};
